import { progressions } from "../../utils/chordUtils";

// Define colors for the progression segments - matching the 4 colors from InteractiveChordProgression
export const SEGMENT_COLORS = [
  "#E9A499", // Light reddish-orange/salmon
  "#23D18E", // Bright teal/mint green
  "#E890FA", // Light purple/lavender
  "#F0BF5F", // Warm golden yellow/orange-yellow
];

// Legacy export for backward compatibility (deprecated - use SEGMENT_COLORS array instead)
export const CHORD_COLORS = SEGMENT_COLORS;

// Default progression
export const DEFAULT_PROGRESSION = progressions.melancholic;
export const DEFAULT_KEY = "C";

// Available keys
export const KEYS = [
  "C",
  "C#",
  "D",
  "D#",
  "E",
  "F",
  "F#",
  "G",
  "G#",
  "A",
  "A#",
  "B",
];
